// extracted by mini-css-extract-plugin
module.exports = {"colourPickerContainer":"ColourPicker_colourPickerContainer__IfGWp","colourItem":"ColourPicker_colourItem__o--J4"};